import React from 'react';
import { Paper, Typography, Switch, Tabs, Tab } from '@material-ui/core';


import MapComponent from '../../components/Map/MapMarkers';


class Map extends React.Component {
    state = {
        firstPeriodMarkers: [],
        firstPeriodMedia: [],
    }

    componentDidMount() {
        if (this.props.data) {
            this.fetchLocations();
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.department !== this.props.department || prevProps.data !== this.props.data) {
            this.fetchLocations()
        }
    }

    handleMapChange = (event, value) => {
        this.setState({ value });
    };

    handleChange = () => {
        this.setState({
            divergencesOnly: !this.state.divergencesOnly
        })
    }

    fetchLocations = () => {

        const { data } = this.props;
        let firstPeriod = [];

        firstPeriod = data.timeclocks;

        firstPeriod = firstPeriod.filter((e) => {
            if (this.props.department > 0) {
                return e.employee.departmentId === this.props.department;
            }
            return e;
        });


        this.setState({
            firstPeriodMarkers: firstPeriod,
            firstPeriodMedia: [data.graph.avgLat, data.graph.avgLng]
        });
    }

    renderMap = () => {

        if (this.state.firstPeriodMarkers.length) {
            let locations = this.state.firstPeriodMarkers;
            let center = this.state.firstPeriodMedia;

            if (center[0]) {
                return (
                    <MapComponent
                        locations={locations}
                        center={center}
                    />
                )
            }

            return <MapComponent />

        } else {
            return <MapComponent />
        }
    }

    renderTotal = () => {
        return this.state.firstPeriodMarkers.length;
    }

    render() {
        const { classes } = this.props;

        return (
            <>
                <div className={classes.gridLine}>
                    <Paper elevation={2} className={classes.paperMap} data-tut="reactour__Mapa" >
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Typography style={{ margin: '0 0 6 0' }} variant="h5" align="left" component="h3" color="textSecondary" gutterBottom>
                                Mapa de Registros
                            </Typography>
                        </div>
 
                        <div className={classes.container}>
                            <div className={classes.map}>
                                {this.renderMap()}
                            </div>
                        </div>
                    </Paper>
                </div>
            </>
        )
    }
}

export default Map;